import React from 'react';
import { Container, Column, Title, Subtitle, Number, Description, TextContainer } from './style';
import { ColumnCenterContent } from '../../style';

import Button from '../button/Button';
import ResultContainer from '../result-container/ResultContainer';

const formatNumber = (num) => {
    return num.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

const CalculationResult = (props) => {
    const {
        sliderValue0,
        sliderValue1,
        sliderValue2,
        sliderValue3,
        sliderValue4,
        sliderValue5,
        inBound,
        outBound,
        mobile,
        metro,
        onClose
    } = props;
    let averageMinutesActivePerMonth = ((sliderValue1 * 60 * 5 * 48) / 12) * sliderValue0 * (1 - sliderValue3 / 100);
    let averageTelcoMinutesConsumedPerMonth = (sliderValue5 * 60 * 5 * 48 / 12 * sliderValue0) * (1 - sliderValue3 / 100);
    let totalCostPerMonthNewWorld = (averageMinutesActivePerMonth * 0.007) + (averageTelcoMinutesConsumedPerMonth * 0.018) + (averageTelcoMinutesConsumedPerMonth * 0.005 * inBound) + (averageTelcoMinutesConsumedPerMonth * 0.025 * outBound);
    let costPerMonth = totalCostPerMonthNewWorld / sliderValue0;
    let costNeonPerMonth = (averageMinutesActivePerMonth * 0.007) / sliderValue0;
    let totalCostPerMonthOldWorld = 0;

    if (averageTelcoMinutesConsumedPerMonth !== 0 && sliderValue4 !== 0) {
        totalCostPerMonthOldWorld = (sliderValue0 * sliderValue2) + ((averageTelcoMinutesConsumedPerMonth * mobile * 0.1) + (averageTelcoMinutesConsumedPerMonth / sliderValue4 * metro * 0.05));
    }

    let monthlySaving = totalCostPerMonthOldWorld - totalCostPerMonthNewWorld;
    let monthlySavingPercent = (monthlySaving / totalCostPerMonthOldWorld) * 100;
    let annualSaving = monthlySaving * 12;

    if (monthlySaving < 0) {
        monthlySaving = 0;
    }
    if (monthlySavingPercent < 0 || monthlySaving === 0) {
        monthlySavingPercent = 0;
    }
    if (annualSaving < 0) {
        annualSaving = 0;
    }

    return (
        <Container>
            <Column border={annualSaving > 0} justifyContent="flex-start">
                <ColumnCenterContent>
                    <Title>
                        NEON
                    </Title>
                    <Subtitle>
                        Comparison Calculator
                    </Subtitle>
                </ColumnCenterContent>
                <ResultContainer
                    number={annualSaving === 0 ? `Contact Us` : formatNumber(`$${annualSaving.toFixed(0)}`)}
                    description={annualSaving > 0 ? 'Annual Saving' : ''}
                    color='#09CFFD'
                    fontSize='28px'
                />
                { annualSaving > 0 && (
                    <>
                        <Number
                            fontSize='28px'
                        >
                            {`${monthlySavingPercent.toFixed(0)}%`}
                        </Number>
                        <ResultContainer
                            number={formatNumber(`$${monthlySaving.toFixed(0)}`)}
                            description='Monthly Saving'
                        />
                    </>
                )}
            </Column>
            { annualSaving > 0 ? (
                <Column border={true}>
                    <Description>
                        Amazon Connect with CloudWave Neon
                    </Description>
                    <ResultContainer
                        number={formatNumber(`$${totalCostPerMonthNewWorld.toFixed(0)}`)}
                        description='Total cost per month'
                        icon='done_outline.svg'
                        iconWidth={20}
                    />
                    <ResultContainer
                        number={formatNumber(`$${costNeonPerMonth.toFixed(0)}`)}
                        description='Cost for NEON per agent per month'
                    />
                </Column>
            ) : (
                <Column>
                    <TextContainer>
                        We need a little more information in order to make an accurate cost saving calculation.
                    </TextContainer>
                    <TextContainer padding={40}>
                        Please contact us today to discuss with our expert team how Neon can save your business money.
                    </TextContainer>
                </Column>
            )}
            <Column justifyContent="flex-end">
                { annualSaving > 0 && (
                    <>
                        <Description>
                            Old World License Model
                        </Description>
                        <ResultContainer
                            number={formatNumber(`$${totalCostPerMonthOldWorld.toFixed(0)}`)}
                            description='Total cost per month'
                            icon='clear.svg'
                            iconWidth={14}
                        />
                    </>
                )}
                <Button
                    onClick={onClose}
                    link={true}
                    href={annualSaving > 0 ? 'https://www.cloudwave.com.au/cloudwave-neon-offer' : 'https://www.cloudwave.com.au/neon-contact-us'}
                    text={annualSaving > 0 ? 'Get Started' : 'Contact Us'}
                    style={{ margin: '24px 0 0 0' }}
                />
            </Column>
        </Container>
    );
};

export default CalculationResult;
